import { BrowserRouter, Routes, Route } from "react-router-dom";
import UserPage from "./UserPage";
import Home from "./Home"
import Privacy from "./Privacy";
import Terms from "./Terms";
import Refund from "./Refund";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="" element={<Home />} />
      </Routes>
      <Routes>
        <Route path="/id/:id" element={<UserPage />} />
      </Routes>
      <Routes>
        <Route path="/privacy" element={<Privacy />} />
      </Routes>
      <Routes>
        <Route path="/terms" element={<Terms />} />
      </Routes>
      <Routes>
        <Route path="/refund" element={<Refund />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;